var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { style: "height:" + _vm.pageHeight + "px", attrs: { id: "main-pos" } },
    [
      _c("vue-progress-bar"),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "content" },
        [
          _vm.pos.section == "choose-product"
            ? _c("chooseproduct-view", {
                staticClass: "choose-product",
                attrs: { ready: _vm.isChooseProductReady, loaded: _vm.ready },
                on: {
                  "update:ready": function($event) {
                    _vm.isChooseProductReady = $event
                  }
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.pos.section == "choose-attribute"
            ? _c("chooseattribute-view", { staticClass: "choose-attribute" })
            : _vm._e(),
          _vm._v(" "),
          _vm.pos.section == "custom-price"
            ? _c("customprice-view", { staticClass: "custom-price" })
            : _vm._e(),
          _vm._v(" "),
          _vm.pos.section == "queues"
            ? _c("queuelist-view", { staticClass: "queues" })
            : _vm._e(),
          _vm._v(" "),
          _vm.pos.section == "tables"
            ? _c("tablelist-view", { staticClass: "tables" })
            : _vm._e(),
          _vm._v(" "),
          _vm.pos.section == "dining-options"
            ? _c("dininglist-view", { staticClass: "dining-options" })
            : _vm._e(),
          _vm._v(" "),
          _vm.pos.section == "customers"
            ? _c("customerlist-view", { staticClass: "customers" })
            : _vm._e(),
          _vm._v(" "),
          _vm.pos.section == "payment"
            ? _c("payment-view", { staticClass: "payment" })
            : _vm._e(),
          _vm._v(" "),
          _vm.pos.section == "payment-complate"
            ? _c("paymentcomplate-view", { staticClass: "payment-complate" })
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c("audio", { ref: "audioPlayer", staticStyle: { display: "none" } }, [
        _c("source", {
          attrs: {
            src: require("@/assets/audios/mixkit-arcade-bonus-alert-767.wav"),
            type: "audio/wav"
          }
        }),
        _vm._v("\n    Your browser does not support the audio element.\n  ")
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2ec6671f", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2ec6671f","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/apps/pos/sale/main/Main.vue
// module id = null
// module chunks = 